import React from 'react';

const aiTechnologies = ["Claude", "Claude Code", "MCP", "Agent Skills"];

const awsTechnologies = [
  "EC2", "S3", "Lambda", "RDS", "CloudFront", "Route 53", 
  "DynamoDB", "ECS", "EKS", "CloudWatch", "IAM", "VPC"
];

interface TechGroupProps {
  label: string;
  items: string[];
  accentClass: string;
  columns: string;
}

const TechGroup: React.FC<TechGroupProps> = ({ label, items, accentClass, columns }) => (
  <div>
    <p className={`font-mono text-eyebrow uppercase ${accentClass}`}>{label}</p>
    <div className={`mt-4 grid gap-px ${columns} overflow-hidden rounded-md bg-gray-700`}>
      {items.map((tech) => (
        <div key={tech} className="flex h-16 items-center justify-center bg-gray-900 px-2">
          <span className="font-mono text-sm text-gray-300">{tech}</span>
        </div>
      ))}
    </div>
  </div>
);

const TechnologiesSection = () => {
  return (
    <div className="py-16 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-measure">
          <h2 className="font-display text-display-md sm:text-display-lg font-bold text-white">
            Technologies We Build With
          </h2>
          <p className="mt-4 text-lg text-gray-400">
            Claude-first for agents. Cloud-agnostic where they run.
          </p>
        </div>

        <div className="mt-10 space-y-8">
          <TechGroup
            label="AI"
            items={aiTechnologies}
            accentClass="text-accent-400"
            columns="grid-cols-2 sm:grid-cols-4"
          />
          <TechGroup
            label="AWS"
            items={awsTechnologies}
            accentClass="text-cloud-400"
            columns="grid-cols-3 sm:grid-cols-4 lg:grid-cols-6"
          />
        </div>
      </div>
    </div>
  );
};

export default TechnologiesSection;
